import { DATE_IN_THE_PAST_WEB } from './cookies.constants';
import { safelyGetUrlInstance } from './cookies.helpers';

/**
 * Deletes a cookie using the CookieStore API.
 * Fallback to overriding the cookie on the document if CookieStore is not available.
 */
export const deleteCookie = async (name: string, url: string) => {
  const urlInstance = safelyGetUrlInstance(url);

  if (!urlInstance) return;

  const domain = urlInstance.hostname;

  if ('cookieStore' in window) {
    const { cookieStore } = window as { cookieStore: CookieStore };

    return cookieStore.delete({ name, domain });
  }

  // eslint-disable-next-line functional/immutable-data, unicorn/no-document-cookie
  document.cookie = `${name}=; expires=${DATE_IN_THE_PAST_WEB}; domain=${domain}; path=/;`;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type CookieStore = {
  delete(options?: CookieDeleteOptions): Promise<void>;
};

type CookieDeleteOptions = {
  name: string;
  domain?: string;
};
